<template>
  <b-card no-body class="shadow border-0 p-3  mb-2 h-100">
    <div class="d-flex justify-content-between">

        <div>
          <p class="text-primary">姓名</p>
          <h5>{{ name }}</h5>
          <p class="text-primary">姓名類型</p>
          <h5>{{ type }}</h5>
        </div>

      <div class="d-flex justify-content-center align-items-center">
        <b-avatar variant="primary" :src="picurl" size="8rem"></b-avatar>
      </div>
    </div>
  </b-card>
</template>
<style>
  .Namecard {
    border-radius: 1rem !important;
  }
</style>
<script>
import {mapState} from 'vuex'
export default {
  name: 'FormSelfBox',
  props: {
  },
  computed:{
    ...mapState(['profiledata']),
    name:function () {return this.profiledata !==null ? this.profiledata.first_name+this.profiledata.last_name : '';},
    type:function () {return this.profiledata.nametype ==0 ? '單姓' : '複姓'},
    picurl:function () {return this.profiledata.pic_url =="" ? '' : this.profiledata.pic_url},
  },
  data() {
    return {

    }
  },
  methods: {


  }
}
</script>
